import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "./NotificationAsset"

export interface IGetNotificationAssetMaintenanceTimeOverdueSoonDto extends IGetNotification {
    notificationType: NotificationType.assetMaintenanceTimeOverdueSoon
    assetId: Guid
    maintenanceTypeName: string
}

export default class NotificationAssetMaintenanceTimeOverdueSoon extends Notification {
    maintenanceTypeName: string
    asset: NotificationAsset

    constructor(dto: IGetNotificationAssetMaintenanceTimeOverdueSoonDto) {
        super(dto)
        this.maintenanceTypeName = dto.maintenanceTypeName
        this.asset = new NotificationAsset({
            assetId: dto.assetId
        })
    }
}
